import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function Contact() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // İletişim sayfasında body overflow'u düzelt
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.title = 'İletişim | Adana İlkyardım Eğitim Merkezi - 0850 346 2772';
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      // Sayfa değiştiğinde temizlik yap
      document.body.style.overflow = '';
      document.body.style.position = '';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d68n0f5bd17lru29ktc0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      {/* Navigation */}
      <header>
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'}`} aria-label="Ana navigasyon">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between py-6">
              <Link to="/">
                <img 
                  src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/6b24d68bdeb9b34d218f93fb0e94b90c.png" 
                  alt="Adana İlkyardım Eğitim Merkezi Logo" 
                  title="Adana İlkyardım Eğitim Merkezi"
                  className="h-40 w-auto object-contain"
                />
              </Link>
              <ul className="flex gap-8 list-none">
                <li><Link to="/" className={`text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Ana Sayfa</Link></li>
                <li><Link to="/egitimler" className={`text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Eğitimler</Link></li>
                <li><Link to="/blog" className={`text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Blog</Link></li>
                <li><Link to="/iletisim" className="text-[#ecad29] text-sm font-medium uppercase tracking-wide relative pb-2 cursor-pointer after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[3px] after:bg-[#ecad29] after:rounded">İletişim</Link></li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <main>
        {/* Hero Section */}
        <section className="pt-40 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#1a1a1a] to-[#2d2d2d]" aria-label="İletişim başlık">
          <div className="max-w-7xl mx-auto text-center">
            <div className="inline-block px-4 py-2 bg-[#ecad29]/20 rounded-full mb-6">
              <span className="text-[#ecad29] text-sm font-medium">Bize Ulaşın</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 font-['Oswald']">
              <a href="#iletisim-formu" className="hover:text-[#ecad29] transition-colors">
                ADANA İLKYARDIM <span className="text-[#ecad29]">İLETİŞİM</span>
              </a>
            </h2>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto">
              Sorularınız için buradayız. <strong>Adana ilkyardım eğitimi</strong> ve <strong>iş güvenliği kursları</strong> hakkında bilgi almak veya kurumsal teklif için bizimle iletişime geçin.
            </p>
          </div>
        </section>

        {/* Contact Content */}
        <section className="py-16 px-4 sm:px-6 lg:px-8" aria-label="İletişim bilgileri ve form">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
              {/* Contact Form */}
              <div className="lg:col-span-3">
                <div className="bg-white rounded-2xl shadow-lg p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    <a href="#iletisim-formu" id="iletisim-formu" className="hover:text-[#ecad29] transition-colors">Mesajınızı Gönderin</a>
                  </h2>
                  
                  {submitStatus === 'success' && (
                    <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl flex items-center gap-3" role="alert">
                      <i className="ri-checkbox-circle-fill text-green-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                      <span className="text-green-700">Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.</span>
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3" role="alert">
                      <i className="ri-error-warning-fill text-red-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                      <span className="text-red-700">Bir hata oluştu. Lütfen tekrar deneyin.</span>
                    </div>
                  )}

                  <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Ad Soyad</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          required
                          value={formData.name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 focus:border-[#ecad29] focus:outline-none transition-colors"
                          placeholder="Adınız Soyadınız"
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">E-posta</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          value={formData.email}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 focus:border-[#ecad29] focus:outline-none transition-colors"
                          placeholder="ornek@email.com"
                        />
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div>
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 focus:border-[#ecad29] focus:outline-none transition-colors"
                          placeholder="+90 (5XX) XXX XX XX"
                        />
                      </div>
                      <div>
                        <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">Konu</label>
                        <select
                          id="subject"
                          name="subject"
                          required
                          value={formData.subject}
                          onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 focus:border-[#ecad29] focus:outline-none transition-colors cursor-pointer"
                        >
                          <option value="">Konu Seçin</option>
                          <option value="İlkyardım Eğitimi">İlkyardım Eğitimi</option>
                          <option value="İş Güvenliği Eğitimi">İş Güvenliği Eğitimi</option>
                          <option value="Kurumsal Teklif">Kurumsal Teklif</option>
                          <option value="Genel Bilgi">Genel Bilgi</option>
                          <option value="Diğer">Diğer</option>
                        </select>
                      </div>
                    </div>
                    
                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Mesajınız</label>
                      <textarea
                        id="message"
                        name="message"
                        required
                        maxLength={500}
                        rows={5}
                        value={formData.message}
                        onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 focus:border-[#ecad29] focus:outline-none transition-colors resize-none"
                        placeholder="Mesajınızı buraya yazın..."
                      />
                      <p className="text-xs text-gray-400 mt-1">{formData.message.length}/500 karakter</p>
                    </div>
                    
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full py-4 bg-[#ecad29] text-white rounded-xl font-medium hover:bg-[#d49a1f] transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSubmitting ? (
                        <>
                          <i className="ri-loader-4-line animate-spin w-5 h-5 flex items-center justify-center"></i>
                          <span>Gönderiliyor...</span>
                        </>
                      ) : (
                        <>
                          <span>Mesaj Gönder</span>
                          <i className="ri-send-plane-fill w-5 h-5 flex items-center justify-center"></i>
                        </>
                      )}
                    </button>
                  </form>
                  
                  <p className="text-xs text-gray-500 mt-4 text-center">
                    Mesajınıza 24 saat içinde yanıt vereceğiz.
                  </p>
                </div>
              </div>

              {/* Contact Info */}
              <aside className="lg:col-span-2 space-y-6" aria-label="İletişim detayları">
                {/* Phone */}
                <div className="bg-white rounded-2xl shadow-lg p-6 flex items-start gap-4">
                  <div className="w-14 h-14 bg-[#ecad29]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-[#ecad29] text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500 mb-1">Telefon</h3>
                    <p className="text-lg font-semibold text-gray-900">
                      <a href="tel:08503462772" className="hover:text-[#ecad29] transition-colors" title="Adana İlkyardım Eğitim Merkezi Telefon">0850 346 2772</a>
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="bg-white rounded-2xl shadow-lg p-6 flex items-start gap-4">
                  <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-fill text-green-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500 mb-1">E-posta</h3>
                    <p className="text-lg font-semibold text-gray-900">
                      <a href="mailto:info@assaakademi.com.tr" className="hover:text-[#ecad29] transition-colors" title="Adana İlkyardım Eğitim Merkezi E-posta">info@assaakademi.com.tr</a>
                    </p>
                  </div>
                </div>

                {/* Address */}
                <div className="bg-white rounded-2xl shadow-lg p-6 flex items-start gap-4">
                  <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-fill text-orange-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500 mb-1">Adres</h3>
                    <address className="not-italic">
                      <p className="text-lg font-semibold text-gray-900">Adana Eğitim Merkezi</p>
                      <p className="text-sm text-gray-600">Reşatbey Mah. Cumhuriyet Cad.</p>
                    </address>
                  </div>
                </div>

                {/* Working Hours */}
                <div className="bg-white rounded-2xl shadow-lg p-6 flex items-start gap-4">
                  <div className="w-14 h-14 bg-[#ecad29]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-fill text-[#ecad29] text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500 mb-1">Çalışma Saatleri</h3>
                    <p className="text-lg font-semibold text-gray-900">Pazartesi - Cuma: 08:00 - 18:00</p>
                    <p className="text-sm text-gray-600">Cumartesi: 09:00 - 15:00</p>
                  </div>
                </div>

                {/* Social Media */}
                <div className="bg-white rounded-2xl shadow-lg p-6">
                  <h3 className="text-sm font-medium text-gray-500 mb-4">Sosyal Medya</h3>
                  <div className="flex items-center gap-3">
                    <a href="#" rel="noopener noreferrer nofollow" className="w-11 h-11 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#ecad29] hover:text-white transition-colors cursor-pointer" aria-label="Instagram">
                      <i className="ri-instagram-line text-xl w-5 h-5 flex items-center justify-center"></i>
                    </a>
                    <a href="#" rel="noopener noreferrer nofollow" className="w-11 h-11 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#ecad29] hover:text-white transition-colors cursor-pointer" aria-label="LinkedIn">
                      <i className="ri-linkedin-fill text-xl w-5 h-5 flex items-center justify-center"></i>
                    </a>
                    <a href="#" rel="noopener noreferrer nofollow" className="w-11 h-11 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#ecad29] hover:text-white transition-colors cursor-pointer" aria-label="Twitter">
                      <i className="ri-twitter-x-fill text-xl w-5 h-5 flex items-center justify-center"></i>
                    </a>
                    <a href="#" rel="noopener noreferrer nofollow" className="w-11 h-11 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#ecad29] hover:text-white transition-colors cursor-pointer" aria-label="YouTube">
                      <i className="ri-youtube-fill text-xl w-5 h-5 flex items-center justify-center"></i>
                    </a>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="px-4 sm:px-6 lg:px-8 pb-16" aria-label="Konum haritası">
          <div className="max-w-7xl mx-auto">
            <h2 className="sr-only">Adana İlkyardım Eğitim Merkezi Konum</h2>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3189.234567890123!2d35.32831240051913!3d36.99610626602804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDU5JzQ2LjAiTiAzNcKwMTknNDEuOSJF!5e0!3m2!1str!2str!4v1699999999999!5m2!1str!2str"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Adana İlkyardım Eğitim Merkezi Konum Haritası"
              />
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="py-6 px-4 sm:px-6 lg:px-8 bg-[#f0e6d2]">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">© 2025 Adana İlkyardım Eğitim Merkezi. Tüm hakları saklıdır.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer nofollow"
            className="text-gray-500 text-xs hover:text-gray-700 transition-colors"
          >
            Website Builder
          </a>
        </div>
      </footer>

      {/* Fixed Contact Icons */}
      <aside className="fixed bottom-6 left-6 z-[150] flex flex-col gap-3" aria-label="İletişim butonları">
        <a 
          href="https://wa.me/905324196401" 
          target="_blank" 
          rel="noopener noreferrer nofollow"
          className="w-12 h-12 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="WhatsApp ile iletişime geçin"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
        <a 
          href="mailto:info@assaakademi.com.tr" 
          className="w-12 h-12 flex items-center justify-center bg-[#ecad29] text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="E-posta gönderin"
          aria-label="E-posta"
        >
          <i className="ri-mail-line text-xl"></i>
        </a>
        <a 
          href="tel:08503462772" 
          className="w-12 h-12 flex items-center justify-center bg-white text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer shadow-md"
          title="Bizi arayın: 0850 346 2772"
          aria-label="Telefon"
        >
          <i className="ri-phone-line text-xl"></i>
        </a>
      </aside>
    </div>
  );
}
